import { render, staticRenderFns } from "./EugenioHome.vue?vue&type=template&id=1b94cf89"
import script from "./EugenioHome.vue?vue&type=script&lang=js"
export * from "./EugenioHome.vue?vue&type=script&lang=js"
import style0 from "./EugenioHome.vue?vue&type=style&index=0&id=1b94cf89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports